import { useEffect } from "react";
import { Printer } from "@phosphor-icons/react";
import { SlabHoldLabel } from "@/components/SlabHoldLabel";

// Shared 4x6 hold-label print preview: renders into #piece-print-area and triggers window.print.
export const printHoldLabels = () => {
  setTimeout(() => {
    document.body.classList.add("printing-piece");
    window.print();
    document.body.classList.remove("printing-piece");
  }, 80);
};

export const HoldLabelPrint = ({ holds, context, onClose, testId = "hold-label" }) => {
  useEffect(() => {
    if (holds?.length) printHoldLabels();
  }, [holds]);
  if (!holds?.length) return null;
  return (
    <div id="piece-print-area" className="mt-3" data-testid={`${testId}-print-area`}>
      <div className="no-print mb-2 flex items-center justify-between gap-3">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500">
          Hold label preview — {holds.length} · 4 × 6 in
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            data-testid={`${testId}-print-again`}
            onClick={printHoldLabels}
            className="flex h-8 items-center gap-1.5 rounded-lg bg-indigo-500 px-3 text-[10px] font-bold uppercase tracking-widest text-white hover:bg-indigo-400"
          >
            <Printer size={13} weight="bold" /> Print
          </button>
          <button
            type="button"
            data-testid={`${testId}-close`}
            onClick={onClose}
            className="flex h-8 items-center rounded-lg border border-zinc-700 px-3 text-[10px] font-bold uppercase tracking-widest text-zinc-300 hover:bg-zinc-800"
          >
            Close
          </button>
        </div>
      </div>
      <div className="label-stack space-y-4">
        {holds.map((h) => (
          <div key={h.id} className="origin-top-left scale-[0.72] sm:scale-100" style={{ width: "4in" }}>
            <SlabHoldLabel hold={h} context={context} />
          </div>
        ))}
      </div>
    </div>
  );
};

// Build a label "hold" object from a slab (and optional piece) record.
export const holdFromSlab = (s, piece) => ({
  id: piece?.id || s.id,
  kind: piece ? "slab_piece" : "slab",
  ref_id: s.id,
  slab_code: s.code,
  color: s.slab_color,
  material: [s.material, s.finish].filter(Boolean).join(" · "),
  thickness: s.thickness,
  location: s.location,
  serial: piece?.serial_number || piece?.name || s.serial_number || "",
  bundle: piece?.bundle_number || s.bundle_number || "",
  length_in: piece?.length_in || s.length_in,
  width_in: piece?.width_in || s.width_in,
});
